module.exports = __webpack_public_path__ + "img/田中暁.59871003.jpg";